<template>
  <div id="contenedor-default-contrato-ejecucion">
    <descargar-reportes
      :key="$route.params.idContrato"
      :reportes="getContratoReportesFisicos"
      :contrato="contrato"
      :catalogo-conceptos="contratoCatalogoConceptosArbol || []"
      :cargando="$apollo.loading">
      <template #barra="descarga">
        <tool-bar v-on:nuevoReporte="registrarNuevoReporte" class="d-print-none">
          <custom-button tipo="agregar" iconText="file_download"
            label="Descargar todos los reportes"
            :disabled="!descarga.disponible || descarga.ocupado"
            :loading="descarga.ocupado" @click="descarga.iniciar" />
        </tool-bar>
      </template>
    </descargar-reportes>
    <!-- Listado -->
    <listado
      class="d-print-none"
      :cargando="$apollo.loading"
      :reportesFisicos="getContratoReportesFisicos"
      :programaContrato="getProgramaContrato">
    </listado>
    <!-- Registrar nuevo reporte fisicos -->
    <v-dialog
      v-if="mostrarVentanaRegistrarNuevoReporte"
      v-model="mostrarVentanaRegistrarNuevoReporte"
      fullscreen
      scrollable
      persistent>
      <v-card>
        <v-card-title>
          Registrar nuevo informe físico
          <v-chip
            v-if="getUltimoReporteFisico"
            class="ml-2">
            {{ ((getUltimoReporteFisico.numero || 0) + 1) }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="$refs.registrarNuevoInforme.cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <nuevo
            :contrato="contrato"
            :ultimoReporteFisico="getUltimoReporteFisico"
            ref="registrarNuevoInforme"
            @cerrar="mostrarVentanaRegistrarNuevoReporte = !mostrarVentanaRegistrarNuevoReporte"
            @formularioValido="setRegistrarFormularioValido">
          </nuevo>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click.prevent="$refs.registrarNuevoInforme.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click.prevent="$refs.registrarNuevoInforme.mixGuardar()"
            :disabled="!registrarFormularioValido"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Editar Reporte Fisico -->
    <v-dialog
      v-if="mostrarEditarReporteFisico"
      v-model="mostrarEditarReporteFisico"
      fullscreen
      scrollable
      persistent>
      <v-card>
        <v-card-title>
          Editar informe físico
          <v-chip
            v-if="esteReporteFisico"
            class="ml-2">
            {{ esteReporteFisico.numero }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="$refs.editarInforme.cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <editar-reporte
            :contrato="contrato"
            :ultimoReporteFisico="getUltimoReporteFisico"
            ref="editarInforme"
            @cerrar="mostrarEditarReporteFisico = !mostrarEditarReporteFisico"
            @formularioValido="setRegistrarFormularioValido">
          </editar-reporte>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click.prevent="$refs.editarInforme.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click.prevent="$refs.editarInforme.mixActualizar()"
            :disabled="!registrarFormularioValido"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Mostrar Reporte Fisico -->
    <v-dialog
      v-if="esteReporteFisico"
      v-model="mostrarReporteFisico"
      fullscreen
      hide-overlay
      scrollable
      transition="dialog-bottom-transition">
      <v-card
        color="bkground"
        class="d-print-none">
        <v-card-title>
          <span
            class="text-uppercase">
            Reporte de avance físico {{ esteReporteFisico.numero }}
          </span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            aria-label="Cerrar reporte"
            @click="cerrarVentanaVerReporteFisico">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ver-reporte
            :reporte-fisico="esteReporteFisico"
            :contrato-reporte="contrato"
            :catalogo-conceptos="contratoCatalogoConceptosArbol || []"
            :cargando-catalogo="$apollo.loading"
            @documento="documentoReporte = $event">
          </ver-reporte>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <acciones-reporte
            :documento="documentoReporte"
            :reporte="esteReporteFisico"
            :contrato="contrato" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-if="esteReporteFisico"
        v-model="mostrarEliminarReporteFisico"
        width="500">
        <eliminar-reporte-fisico
          :reporteFisicoEliminar="esteReporteFisico"
          v-on:cerrar="cerrarEliminarReporte"
        />
    </v-dialog>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import CONTRATO_REPORTES_FISICOS from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratoReportesFisicos.gql';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_CATALOGO_ARBOL from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoConceptosArbol.gql';
import CONTRATO_PROGRAMAS_OBRA from '@/graphql/querys/administracion/contratos/programa/contratoProgramasObra.gql';
import EliminarReporteFisico from '@/components/administracion/ejecucion/reportes/Eliminar.vue';
import AccionesReporte from '@/components/administracion/ejecucion/reportes/documento/AccionesReporte.vue';
import DescargarReportes from '@/components/administracion/ejecucion/reportes/documento/DescargarReportes.vue';
import Nuevo from '@/components/administracion/ejecucion/reportes/nuevo/Main.vue';
import EditarReporte from '@/components/administracion/ejecucion/reportes/editar/Main.vue';
import CustomButton from '@/components/buttons/Button.vue';
import Listado from './listado/Main.vue';
import ToolBar from '../ToolBar.vue';
import VerReporte from './reporte/Main.vue';

export default {
  name: 'MainContratoEjecucionReportes',
  components: {
    EliminarReporteFisico,
    ToolBar,
    Listado,
    VerReporte,
    AccionesReporte,
    DescargarReportes,
    Nuevo,
    EditarReporte,
    CustomButton,
  },
  data() {
    return {
      documentoReporte: '',
      mostrarVentanaRegistrarNuevoReporte: false,
      mostrarEditarReporteFisico: false,
      mostrarEliminarReporteFisico: false,
      mostrarReporteFisico: false,
      esteReporteFisico: null,
      registrarFormularioValido: false,
      // reporteKey: Date.now(),
    };
  },
  apollo: {
    contratoReportesFisicos: {
      query: CONTRATO_REPORTES_FISICOS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoCatalogoConceptosArbol: {
      query: CONTRATO_CATALOGO_ARBOL,
      variables() {
        return { idContrato: this.$route.params.idContrato };
      },
    },
    contratoProgramasObra: {
      query: CONTRATO_PROGRAMAS_OBRA,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  mounted() {
    eventBus.$on('ver-reporte-fisico', this.verReporte);
    eventBus.$on('editar-reporte-fisico', this.editarReporte);
    eventBus.$on('eliminar-reporte-fisico', this.eliminarReporte);
  },
  beforeDestroy() {
    eventBus.$off('ver-reporte-fisico', this.verReporte);
    eventBus.$off('editar-reporte-fisico', this.editarReporte);
    eventBus.$off('eliminar-reporte-fisico', this.eliminarReporte);
  },
  methods: {
    verReporte(reporte) {
      this.documentoReporte = '';
      this.esteReporteFisico = reporte;
      this.mostrarReporteFisico = true;
    },
    editarReporte(reporte) {
      this.esteReporteFisico = reporte;
      this.mostrarEditarReporteFisico = true;
    },
    eliminarReporte(reporte) {
      this.esteReporteFisico = reporte;
      this.mostrarEliminarReporteFisico = true;
    },
    setRegistrarFormularioValido(valor) {
      this.registrarFormularioValido = valor;
    },
    registrarNuevoReporte() {
      this.mostrarVentanaRegistrarNuevoReporte = true;
    },
    cerrarRegistrarNuevoReporte() {
      this.mostrarVentanaRegistrarNuevoReporte = false;
      this.registrarFormularioValido = false;
    },
    cerrarEditarReporte() {
      this.esteReporteFisico = null;
      this.mostrarEditarReporteFisico = false;
    },
    cerrarVentanaVerReporteFisico() {
      this.esteReporteFisico = null;
      this.mostrarReporteFisico = false;
      this.documentoReporte = '';
    },
    cerrarEliminarReporte() {
      this.mostrarEliminarReporteFisico = false;
    },
  },
  computed: {
    getContratoReportesFisicos() {
      if (!this.contratoReportesFisicos) return [];
      return [...this.contratoReportesFisicos].sort((a, b) => b.numero - a.numero);
    },
    getUltimoReporteFisico() {
      const [ultimo] = this.getContratoReportesFisicos;
      if (!ultimo) return {};
      return ultimo;
    },
    getProgramaContrato() {
      if (!this.contratoProgramasObra || !this.contratoProgramasObra.length) {
        console.warn('No hay programas de obra disponibles');
        return null;
      }

      // Tomamos el primer elemento de contratoProgramasObra
      const programaObra = this.contratoProgramasObra[0];

      // El campo 'programa' es un array de períodos consecutivos
      const programas = programaObra?.programa;

      if (!programas || !programas.length) {
        console.warn('No hay programas en el array');
        return null;
      }

      // Ordenar programas por fecha de inicio (para obtener el inicio original)
      const programasOrdenadosPorInicio = [...programas].sort((a, b) => {
        const fechaA = this.$moment(a.fechaInicio);
        const fechaB = this.$moment(b.fechaInicio);
        return fechaA.diff(fechaB);
      });

      // Ordenar programas por fecha de término (para obtener el término más reciente)
      const programasOrdenadosPorTermino = [...programas].sort((a, b) => {
        const fechaA = this.$moment(a.fechaTermino);
        const fechaB = this.$moment(b.fechaTermino);
        return fechaA.diff(fechaB);
      });

      // Tomar la fecha de inicio del primer programa
      const primerPrograma = programasOrdenadosPorInicio[0];
      // Tomar la fecha de término del último programa (más reciente)
      const ultimoPrograma = programasOrdenadosPorTermino[programasOrdenadosPorTermino.length - 1];

      // Crear objeto con el rango completo del contrato
      const programaCompleto = {
        fechaInicio: primerPrograma.fechaInicio,
        fechaTermino: ultimoPrograma.fechaTermino,
        plazo: programas.reduce((sum, p) => sum + (p.plazo || 0), 0),
      };

      console.log('✅ Programa completo calculado:', {
        totalPeriodos: programas.length,
        fechaInicio: this.$moment(programaCompleto.fechaInicio).format('DD/MM/YYYY'),
        fechaTermino: this.$moment(programaCompleto.fechaTermino).format('DD/MM/YYYY'),
        plazoTotal: programaCompleto.plazo,
      });

      return programaCompleto;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
